module.exports = __webpack_public_path__ + "static/img/fern.edfbe21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/fern.png
// module id = DW/9
// module chunks = 0